$(document).ready(function () {
    let field = document.querySelector('a[href="#tabPosition"]');

    let activeTab = document.querySelector('.nav-item .nav-link.active');

    if (activeTab && activeTab.getAttribute('aria-controls') === 'tabPosition') {
        Livewire.dispatch('refreshPositionsTable');
    }

    $(field).on('click', function () {
        Livewire.dispatch('refreshPositionsTable');
    });
});
